module.exports = __webpack_public_path__ + "static/16-2f011a333d9bff8b19359c50d82df29d.jpg";